//@flow
import {
  UPDATE_TEAM_REQUEST,
  CHANGE_TEAM_NAME,
  CHANGE_TEAM_PICTURE,
  CREATE_TEAM_CONVERSATION_REQUEST,
} from "./constants";

export const updateTeamRequest = (payload: {
  teamId: String;
  firstName: String;
  name: String;
  userId: string;
}) => {
  return {
    type: UPDATE_TEAM_REQUEST,
    payload,
  };
};

export const onChangeName = (payload: string) => {
  return {
    type: CHANGE_TEAM_NAME,
    payload,
  };
};

export const onChangePicture = (payload: {
  name: string;
  uri: string;
  picture: string;
}) => {
  return {
    type: CHANGE_TEAM_PICTURE,
    payload,
  };
};

export const createConversation = (payload: {
  userId: string,
  teamId: string,
}) => {
  return {
    type: CREATE_TEAM_CONVERSATION_REQUEST,
    payload,
  };
};
